<section class="page-not-found">
  <div class="page-not-found__container">
    <h1 class="page-not-found__heading">404: Page not found</h1>
    <div class="page-not-found__divider"></div>
    <p class="page-not-found__subheading">The link you clicked may be broken or the page may have moved.</p>
    <p class="page-not-found__subheading">
      You can visit the
      <a routerLink="/home" class="page-not-found__link">homepage</a>
      or
      <a routerLink="/help" class="page-not-found__link">contact us</a>
      .
    </p>
  </div>
</section>
